import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react'
import React, { useState } from 'react'
import { CustomBtn } from './CustomBtn'
import { deactivateDirectDebit } from '../services/loanRepayments'

const StopDirectDebit = ({datum}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false);
    const authorizationCode = datum?.directDebitDetails?.authorizationCode
    const handleCancel = async () => {
        setLoading(true);
        const payload = {
         authorizationCode
        };
        await deactivateDirectDebit(payload, setLoading, setRefresh, onClose)
      };
  return (
    <Box>
        <Text textAlign={"center"} fontSize={"20px"} fontWeight={"bold"}>Stop Direct Debit from this account</Text>
        <Flex mt={"20px"}>
            <CustomBtn loading={loading} text={"Cancel"} width={"full"} bg={"red"} handleClick={handleCancel}/>
        </Flex>
    </Box>
  )
}
export default StopDirectDebit